import { Box, Actions, ActionsProps, Bleed } from '@machobear/design-system'
export default function DialogActions({
  children,
  align = 'right'
}: {
  children: ActionsProps['children']
  align?: ActionsProps['align']
}) {
  return (
    <Bleed horizontal="large" bottom="large">
      <Box background="body" paddingX="large" paddingY="large" borderTop="borderField">
        <Actions align={align}>{children}</Actions>
      </Box>
    </Bleed>
  )
}
